@import (reference) "../../references.less";

.root {
  cursor: pointer;

  background-color: @color-blue-2;

  @topBottom-mobile: 5;
  @leftRight-mobile: 8;
  @topBottom-laptop: 40;
  @leftRight-laptop: 40;
  .R(padding-top, @topBottom-mobile, @topBottom-laptop, @breakpoint: @breakpoint-laptop);
  .R(padding-bottom, @topBottom-mobile, @topBottom-laptop, @breakpoint: @breakpoint-laptop);
  .R(padding-left, @leftRight-mobile, @leftRight-laptop, @breakpoint: @breakpoint-laptop);
  .R(padding-right, @leftRight-mobile, @leftRight-laptop, @breakpoint: @breakpoint-laptop);

  border-radius: 10px;

  &:active {
    opacity: 0.8;
  }

  &:hover {
    .svg {
      path {
        fill: @color-white;
      }
    }
  }

  .label {
    color: @color-white;
  }

  &_isWaitingSources {
    background-color: @color-red;

    .svg {
      path {
        fill: @color-white;
      }
      .element-blink-animation();

      @media (min-width: @breakpoint-laptop) {
        animation: none;
        transition: none;
      }
    }

    .label {
      .element-blink-animation();
    }
  }
}

.svg {
  .R(width, 20, 40, @breakpoint-laptop);
  @media (min-width: @breakpoint-laptop) {
  }

  path {
    fill: @color-red;
  }
}

.label {
  display: none;
  @media (min-width: @breakpoint-laptop) {
    display: block;
    .R(margin-top, 10);
    color: @color-white;
    transition: all ease-out 200ms;
    .R(font-size, 18);
    line-height: 1.6em;
  }
}
